// Global CSS
import './src/assets/css/globalReset.css';
import './src/assets/css/globalFonts.css';
import './src/assets/css/globalStyles.css';

// Global state
import Provider from './src/components/Provider';

export const wrapRootElement = Provider;
